import { render, staticRenderFns } from "./RuleItemMenu.vue?vue&type=template&id=609571e2"
import script from "./RuleItemMenu.vue?vue&type=script&lang=ts"
export * from "./RuleItemMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports